import React from "react";
import TextInput, { DGA_TextInputProps, Style } from "../TextInput";
import { mergeStrings } from "../../lib/helpers";
import styled from "styled-components";
import plusIcon from "./plus.png";
import minusIcon from "./minus.png";

type PrefixSuffixStyle = "plus" | "minus";

export interface DGA_NumberInputProps extends Omit<DGA_TextInputProps, "icon"> {
  prefixType?: PrefixSuffixStyle;
  suffixType?: PrefixSuffixStyle;
}

const plusIconJsx = <img src={plusIcon} style={{ width: 17.5 }} />;
const minusIconJsx = <img src={minusIcon} style={{ width: 17.5 }} />;

const NumberInput = React.forwardRef<HTMLInputElement, DGA_NumberInputProps>(
  ({ prefixType = "plus", suffixType = "minus", ...props }, ref) => {
    return (
      <StyledComponent
        className={mergeStrings("dgaui dgaui_numberInput", props.className)}
        ref={ref}
        prefix={prefixType === "plus" ? plusIconJsx : minusIconJsx}
        suffix={suffixType === "plus" ? plusIconJsx : minusIconJsx}
        prefixStyle={
          props.prefixStyle
            ? props.prefixStyle
            : props.style === "filledLighter"
            ? "subtle"
            : undefined
        }
        suffixStyle={
          props.suffixStyle
            ? props.suffixStyle
            : props.style === "filledLighter"
            ? "subtle"
            : undefined
        }
        {...props}
        onWheel={(e) => {
          (e.target as any).blur();
        }}
        type="number"
        pattern="[0-9]*"
        inputMode="numeric"
        onKeyDown={(e) => {
          (e.key === "e" || e.key === "E") && e.preventDefault();
          props.onKeyDown?.(e);
        }}
      />
    );
  }
);

const StyledComponent = styled(TextInput)`
  input[type="number"] {
    appearance: textfield;
    -moz-appearance: textfield;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  .prefix,
  .suffix {
    cursor: pointer;
  }

  img {
    user-select: none;
  }

  &:has(input:disabled) {
    .prefix,
    .suffix {
      pointer-events: none;
    }
    img {
      filter: brightness(8);
    }
  }
`;

export default NumberInput;
